import { combineReducers } from '@reduxjs/toolkit';
import { default as datapoints } from './datapoints';
import editedStoreFamilyClusterDatapoints from './editedStoreFamilyClusterDatapoints';
import pagination from './pagination';
import sort from './sort';
import totalElements from './totalElements';

const rootReducer = combineReducers({
  datapoints,
  pagination,
  totalElements,
  sort,
  editedStoreFamilyClusterDatapoints,
});

export type GetStoreFamilyClusterModalStateProps = ReturnType<typeof rootReducer>;

export default rootReducer;
